import { gettext } from '@eventbrite/i18n';
import React from 'react';
import { getEventbriteUrl } from '../utils';

export interface ImplicitToSFooterDisclaimerProps {
    ctaText: string;
    locale: string;
}

export const ImplicitToSFooterDisclaimer: React.FunctionComponent<
    ImplicitToSFooterDisclaimerProps
> = ({ ctaText, locale }) => {
    const urlPrefix = getEventbriteUrl(locale);

    const tosLink = `<a href="${urlPrefix}/tos" class="eds-link" target="_blank" id="tos" rel="noopener noreferrer">${gettext(
        'Eventbrite Terms of Service',
    ).toString()}</a>`;
    const communityGuidelinesLink = `<a href="${urlPrefix}/community-guidelines" class="eds-link" id="community-guidelines" target="_blank" rel="noopener noreferrer">${gettext(
        'Community Guidelines',
    ).toString()}</a>`;
    const privacyPolicyLink = `<a href="${urlPrefix}/privacypolicy" class="eds-link" id="privacy-policy" target="_blank" rel="noopener noreferrer">${gettext(
        'Privacy Policy',
    ).toString()}</a>`;
    const TOS_TEXT = gettext(
        'By clicking "%(ctaText)s", I accept the %(tosLink)s, %(communityGuidelinesLink)s and have read the %(privacyPolicyLink)s',
        { tosLink, communityGuidelinesLink, privacyPolicyLink, ctaText },
    ).toString();

    return (
        <span
            className="eds-text-color--ui-700"
            data-spec="checkout-implicit-footer-tos-disclaimer"
            // eslint-disable-next-line react/no-danger
            dangerouslySetInnerHTML={{
                __html: TOS_TEXT,
            }}
        />
    );
};
